import { Helmet } from "react-helmet-async";
import { SITE } from "@/lib/constants";

interface SEOProps {
  title: string;
  description: string;
  path: string; // e.g. "/", "/about", "/services/coaching"
  jsonLd?: object | object[];
  ogType?: "website" | "article" | "profile";
  noindex?: boolean;
  image?: string; // absolute URL preferred; relative paths will be resolved against SITE.domain
}

const DEFAULT_OG_IMAGE =
  "https://pub-bb2e103a32db4e198524a2e9ed8f35b4.r2.dev/babb1b90-d4ef-4621-a472-87e9891eeea3/id-preview-eee405f7--f48365b5-d92b-43dd-90ed-f95e4b04eaad.lovable.app-1772720902948.png";

const SEO = ({
  title,
  description,
  path,
  jsonLd,
  ogType = "website",
  noindex = false,
  image,
}: SEOProps) => {
  const url = `${SITE.domain}${path === "/" ? "" : path}`;
  const fullTitle = path === "/" ? title : `${title} | ${SITE.name}`;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  const resolvedImage = image
    ? image.startsWith("http")
      ? image
      : `${SITE.domain}${image.startsWith("/") ? image : `/${image}`}`
    : DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={resolvedImage} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={resolvedImage} />

      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
